import { navigateTo, reloadNuxtApp, useRuntimeConfig } from "#imports"
import { defineStore } from 'pinia'

export const authStore = defineStore('auth', {
  persist: {
    storage: persistedState.localStorage,
  },
  state: () => ({
    data: null,
    rawToken: null,
    lastRefreshedAt: useNuxtApp().$dayjs(),
    authenticated: false,
    loading: false,
    config: useRuntimeConfig().public,
    isDialogVisible: false,
    msgDialog: '',
  }),
  getters: {
    menu() {
      if (!this.authenticated || !this.data?.context) return []
    
      const final = []
    
      Object.entries(this.data.context).forEach(([idContext, infoContext]) => {
        if (!infoContext.menu) return
    
        const contextName = infoContext.name
    
        infoContext.menu.forEach(menu => {
          const parts = menu.split('/')
          const firstPart = parts[0]
          const lastPart = parts[parts.length - 1]
    
          const temp = {
            title: firstPart,
            i18n: firstPart,
            icon: { icon: useNuxtApp().$i18n.t(`${firstPart}_icon`) },
            children: [],
          }
    
          const subitem = {
            to: `/${menu}`,
            title: contextName || lastPart,
            i18n: contextName ? '' : `/${menu}`,
            context: infoContext.info.CNTX_type !== 'site' ? idContext : 0,
            icon: { icon: useNuxtApp().$i18n.t(`${contextName ? '' : `/${menu}`}_icon`) },
          }
    
          let item = parts.slice(1, -1).reduce((acc, part) => {
            acc.title = part
            acc.i18n = `${temp.title}/${part}`
            acc.icon = { icon: useNuxtApp().$i18n.t(`${acc.i18n}_icon`) }
            acc.children = acc.children || []
            
            return acc
          }, {})
    
          if (item.children) {
            item.children.push(subitem)
          } else {
            item = subitem
            item.icon = { icon: useNuxtApp().$i18n.t(`/${menu}_icon`) }
          }
    
          temp.children.push(item)
    
          const existingTemp = final.find(obj => obj.title === temp.title)
          if (existingTemp) {
            const existingItem = existingTemp.children.find(obj => obj.title === temp.children[0].title)
            if (existingItem?.children) {
              existingItem.children.push(temp.children[0].children[0])
            } else {
              existingTemp.children.push(temp.children[0])
            }
          } else {
            final.push(temp)
          }
        })
      })
    
      return final
    },
    
  },
  actions: {
    toggleDialog(msg = "", open = true) {
      this.isDialogVisible = open
      this.msgDialog = msg
    },
    async signIn(userData = {}, params = {}, dialog = false) {
      const { path, method } = this.config.auth.provider.endpoints.signIn
      /* eslint-disable */
      const payload = {
        client_id: this.config.apiClient,
        client_secret: this.config.apiSecret,
        grant_type: 'password',
        ...userData,
      }

    /* eslint-enable */
      try {
        const data = await $api(`${path}?context_id=0`, { method, body: payload })
    
        if (!data?.access_token) {
          throw new Error("No access token received")
        }
    
        this.loading = true
        this.rawToken = data.access_token
        this.authenticated = true
    
        localStorage.setItem("accessToken", `Bearer ${this.rawToken}`)
        await this.getSession()
    
        if (dialog) {
          this.toggleDialog("", false)
          
          return reloadNuxtApp()
        }
    
        return navigateTo(this.config.auth.provider.pages.signIn || "/home")
      } catch (error) {
        this.authenticated = false
        this.rawToken = null
        localStorage.removeItem("accessToken")
    
        console.error("Login failed:", error)
        if (dialog) this.toggleDialog("error_login", true)
    
        throw error
      }
    },

    async getSession (){
      const { path, method } = this.config.auth.provider.endpoints.getSession
      const data = await $api(`${path}?context_id=0`, { method })

      this.data = data
      this.loading = false
      this.lastRefreshedAt =  useNuxtApp().$dayjs()
      
      return data
    },
    async signOut() {
      const { path, method } = this.config.auth.provider.endpoints.getSession
      
      localStorage.removeItem('accessToken')
      this.rawToken = null
      this.data = null
      this.authenticated = false // set authenticated  state value to false
      /*
      const data = await useFetch(`${path}?context_id=0`, { method})
      */

      return navigateTo(this.config.auth.provider.pages.signOut || "/", { external: true })
    },
    setAuthenticated(val) {
      this.authenticated = val
    },
  },
})
